document.addEventListener('DOMContentLoaded', function() {
  // Only run on home page
  if (document.body.classList.contains('template-index')) {
    const headerSection = document.querySelector('.shopify-section-header-sticky');
    
    if (headerSection) {
      window.addEventListener('scroll', function() {
        const scrollPosition = window.scrollY;
        
        if (scrollPosition > 50) {
          headerSection.classList.add('scrolled');
        } else {
          headerSection.classList.remove('scrolled');
        }
      });
    }
  }
});